import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaHome, FaGem, FaHeart, FaShoppingCart, FaUser,
  FaSearch, FaTh, FaBars
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useCart } from '../../context/CartContext';
import { useTheme } from '../../context/ThemeContext';
import { useUser } from '../../context/UserContext';

const MobileNavbar = () => {
  const location = useLocation();
  const { getCartItemsCount, setIsCartOpen, wishlistItems } = useCart();
  const { isDarkMode } = useTheme();
  const { isAuthenticated } = useUser();
  const navigate = useNavigate()
  const navItems = [
    { icon: FaHome, label: 'Home', path: '/', id: 'home' },
    { icon: FaTh, label: 'Shop', path: '/collections', id: 'shop' },
    { icon: FaSearch, label: 'Search', path: '/search', id: 'search' },
    { icon: FaHeart, label: 'Wishlist', path: '/wishlist', id: 'wishlist', badge: wishlistItems.length },
    { icon: FaUser, label: 'Profile', path: isAuthenticated ? '/profile' : '/login', id: 'profile' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Top Header */}
      <div className="d-lg-none mobile-header" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1029,
        background: isDarkMode ? 'var(--bg-secondary)' : 'white',
        padding: '10px 15px',
        boxShadow: '0 2px 10px rgba(128, 0, 32, 0.08)',
        borderBottom: '1px solid var(--border-color)'
      }}>
        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/"
            className="text-decoration-none d-flex align-items-center"
          >
            <img
              src="/logo.png"
              alt="logo"
              style={{
                width: "150px",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Link>
          <button
            onClick={() => navigate("/cart")}
            className="btn position-relative"
            style={{
              background: 'var(--gradient-maroon)',
              color: 'white',
              borderRadius: '12px',
              padding: '8px 12px'
            }}>
            <FaShoppingCart />
            {getCartItemsCount() > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                style={{ fontSize: '10px' }}>
                {getCartItemsCount()}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="d-lg-none mobile-bottom-nav" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1030,
        background: isDarkMode ? 'var(--bg-secondary)' : 'white',
        boxShadow: '0 -4px 20px rgba(128, 0, 32, 0.1)',
        borderTop: '1px solid var(--border-color)',
        borderRadius: '20px 20px 0 0',
        paddingBottom: 'env(safe-area-inset-bottom)'
      }}>
        <div className="mobile-nav-icons" style={{
          display: 'flex',
          justifyContent: 'space-around',
          padding: '8px 0'
        }}>
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);

            return (
              <Link
                key={item.id}
                to={item.path}
                className="mobile-nav-icon"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px',
                  color: active ? 'var(--primary-maroon)' : 'var(--text-secondary)',
                  textDecoration: 'none',
                  position: 'relative',
                  transition: 'all 0.3s ease'
                }}>
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  style={{ position: 'relative' }}>
                  <Icon style={{
                    fontSize: '22px',
                    marginBottom: '2px'
                  }} />
                  {item.badge > 0 && (
                    <span style={{
                      position: 'absolute',
                      top: '-5px',
                      right: '-8px',
                      background: 'var(--primary-maroon)',
                      color: 'white',
                      fontSize: '9px',
                      padding: '2px 5px',
                      borderRadius: '10px',
                      minWidth: '16px',
                      textAlign: 'center'
                    }}>
                      {item.badge}
                    </span>
                  )}
                </motion.div>
                <span style={{
                  fontSize: '10px',
                  fontWeight: active ? '600' : '400',
                  marginTop: '2px'
                }}>
                  {item.label}
                </span>
                {active && (
                  <motion.div
                    layoutId="activeTab"
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      width: '40px',
                      height: '3px',
                      background: 'var(--gradient-maroon)',
                      borderRadius: '3px'
                    }}
                  />
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MobileNavbar;